import React from "react";

const IconSymbolTaka = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={51}
      viewBox="0 0 36 51"
      fill="none"
      {...props}
    >
      <path
        d="M26.6172 34.8911C26.6172 35.7007 26.911 36.4772 27.434 37.0497C27.957 37.6223 28.6663 37.9439 29.4059 37.9439C30.1456 37.9439 30.8549 37.6223 31.3779 37.0497C31.9009 36.4772 32.1947 35.7007 32.1947 34.8911C32.1947 34.0814 31.9009 33.3049 31.3779 32.7324C30.8549 32.1599 30.1456 31.8383 29.4059 31.8383C28.6663 31.8383 27.957 32.1599 27.434 32.7324C26.911 33.3049 26.6172 34.0814 26.6172 34.8911Z"
        stroke="white"
        strokeWidth="6.50569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.91406 9.24759C2.91406 7.54731 3.53107 5.91666 4.62936 4.71438C5.72765 3.5121 7.21724 2.83667 8.77045 2.83667C10.3237 2.83667 11.8133 3.5121 12.9115 4.71438C14.0098 5.91666 14.6268 7.54731 14.6268 9.24759V38.0967C14.6268 40.6471 15.5524 43.0931 17.1998 44.8965C18.8472 46.6999 21.0816 47.7131 23.4114 47.7131C25.7412 47.7131 27.9756 46.6999 29.6231 44.8965C31.2705 43.0931 32.196 40.6471 32.196 38.0967V36.494M5.84226 22.0694H23.4114"
        stroke="white"
        strokeWidth="4.87927"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconSymbolTaka;
